import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

@Component({
  selector: 'app-cvv',
  templateUrl: './cvv.component.html',
  styleUrls: ['./cvv.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[id]': 'id',
  },
})
export class CvvComponent extends FieldType<FieldTypeConfig> implements OnInit {

  ngOnInit(): void {
    this.formControl.addValidators(this.cvvValidator());
  }

  cvvValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (value?.trim()) {
        if (!value.test("^-?\\d+$")) {
          return { mustBeNumeric: true };
        }
        if ( !(value.length > 1 && value.length < 5) ) {
          return { cvvLength: true };
        }
      }
      return null;
    };
  }
}